// @flow
import * as React from 'react';

import { useNavigate } from 'react-router-dom';

import { selectCartUUID } from '@gandi/cart';
import { useTranslator } from '@gandi/translate';
import { PillSwitch, PillSwitchPill } from '@gandi/ui';

import { useAppSelector } from 'src/hooks/useAppSelector';

import { withRouter } from '../helpers/withRouter';

type OwnProps = {
  process: 'create' | 'renew' | 'transfer',
};

type Props = {
  ...OwnProps,
};

function DomainProcessNavSwitch({ process }: Props): React.MixedElement {
  const { __ } = useTranslator();
  const navigate = useNavigate();
  const cartId = useAppSelector(selectCartUUID);

  return (
    <PillSwitch
      name="domain-process-nav-switch"
      value={process}
      onValueChange={value => {
        // The create process is done through the domain/suggest page
        // instead we could add a redirect to the routes
        const page = value === 'create' ? 'suggest' : value;

        navigate(`/domain/${page}/${cartId}`);
      }}
    >
      {[
        { value: 'create', label: __('Register') },
        { value: 'renew', label: __('Renew') },
        { value: 'transfer', label: __('Transfer') },
      ].map(({ value, label }) => (
        <PillSwitchPill value={value} key={value}>
          {label}
        </PillSwitchPill>
      ))}
    </PillSwitch>
  );
}

export default (withRouter(
  DomainProcessNavSwitch,
): React.ComponentType<OwnProps>);
